import { Swiper, Autoplay } from "swiper"

Swiper.use(Autoplay)

function logoSwiper() {
    document.querySelectorAll(".logo-swiper").forEach((element) => {
        const wrapper = element.closest(".logo-swiper-wrapper")
        const swiper = new Swiper(element, {
            slidesPerView: 2,
            spaceBetween: 24,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                },
            },
        })

        const arrowPrev = wrapper?.querySelector(".arrow-prev")
        const arrowNext = wrapper?.querySelector(".arrow-next")

        arrowPrev?.addEventListener("click", () => {
            swiper.slidePrev()
        })

        arrowNext?.addEventListener("click", () => {
            swiper.slideNext()
        })
    })
}

if (document.querySelector(".logo-swiper-wrapper")) {
    logoSwiper()
}
